import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { agentSeatAssignmentService } from "@/services/agent-seat-assignment-service";
import { AgentSeatAssignment, CreateAgentSeatAssignmentDto } from "@/types/agent-seat-assignment.types";

export const agentSeatAssignmentKeys = {
    all: ["agent-seat-assignments"] as const,
    list: () => [...agentSeatAssignmentKeys.all, "list"] as const,
};

export const useAgentSeatAssignments = () => {
    return useQuery({
        queryKey: agentSeatAssignmentKeys.list(),
        queryFn: () => agentSeatAssignmentService.getAll(),
    });
};
export const useInvalidateAgentSeatAssignments = () => {
    const queryClient = useQueryClient();
    return () => {
        queryClient.invalidateQueries({ queryKey: agentSeatAssignmentKeys.list() });
    };
};

export const useCreateAgentSeatAssignment = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (data: CreateAgentSeatAssignmentDto) => agentSeatAssignmentService.create(data),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: agentSeatAssignmentKeys.list() });
        },
    });
};

export const useUpdateAgentSeatAssignment = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: ({
            tableId,
            seatNumber,
            update,
        }: {
            tableId: string;
            seatNumber: number;
            update: Partial<AgentSeatAssignment>;
        }) => agentSeatAssignmentService.update(tableId, seatNumber, update),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: agentSeatAssignmentKeys.list() });
        },
    });
};

export const useDeleteAgentSeatAssignment = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: ({ tableId, seatNumber }: { tableId: string; seatNumber: number }) =>
            agentSeatAssignmentService.delete(tableId, seatNumber),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: agentSeatAssignmentKeys.list() });
        },
    });
};
